import DashboardIcon from "@mui/icons-material/DashboardOutlined";
import LocalShippingIcon from "@mui/icons-material/LocalShippingOutlined";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLongOutlined";
import PaidIcon from "@mui/icons-material/PaidOutlined";
import StorefrontIcon from "@mui/icons-material/StorefrontOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";

const sidebarConfig = [
  { label: "Dashboard", path: "/delivry-company/dashboard", icon: DashboardIcon },
  { label: "Drivers", path: "/delivry-company/drivers", icon: LocalShippingIcon },
  { label: "Orders", path: "/delivry-company/orders", icon: ReceiptLongIcon },
  { label: "Driver Access", path: "/delivry-company/driver-access", icon: AdminPanelSettingsOutlinedIcon },
  { label: "Fees", path: "/delivry-company/fees", icon: PaidIcon },
  { label: "Store Fees", path: "/delivry-company/store-fees", icon: StorefrontIcon },
];

export default sidebarConfig;
